import { __assign, __extends } from "tslib";
import React from 'react';
import LoveButton from './loveButton.js';
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import { utils } from '../utils';
import { translationUtils } from '@wix/photography-client-lib';
import FullscreenExpandCloseButton from './FullscreenExpandCloseButton';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import InvertInfo from './icons/info-invert';
// eslint-disable-next-line import/no-unresolved
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import Info from 'wix-ui-icons-common/on-stage/Info';
import Share from 'wix-ui-icons-common/on-stage/Share';
var FullscreenDesktopNavbar = /** @class */ (function (_super) {
    __extends(FullscreenDesktopNavbar, _super);
    function FullscreenDesktopNavbar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleShareArrowNavigation =
            _this.handleShareArrowNavigation.bind(_this);
        _this.onShareIconClick = _this.onShareIconClick.bind(_this);
        _this.state = {
            shareBoxIsOpened: false,
            focusedShareIcon: 0,
        };
        return _this;
    }
    FullscreenDesktopNavbar.prototype.componentDidMount = function (prevProps) {
        var _a;
        (_a = this.fullscreenExpandButton) === null || _a === void 0 ? void 0 : _a.focus();
    };
    FullscreenDesktopNavbar.prototype.componentDidUpdate = function (prevProps) {
        var _a;
        if (prevProps.currentWindow.expanded !== this.props.currentWindow.expanded) {
            if (!this.props.currentWindow.expanded) {
                (_a = this.fullscreenExpandButton) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    };
    FullscreenDesktopNavbar.prototype.hasAdditionalNavbarElement = function () {
        var additionalNavbarElement = this.props.additionalNavbarElement;
        return typeof additionalNavbarElement === 'function';
    };
    FullscreenDesktopNavbar.prototype.handleShareArrowNavigation = function (e, type) {
        if (!this.state.shareBoxIsOpened) {
            // the keypress events are only effective when the share box was opened via Click or Focus+Enter
            return true;
        }
        switch (e.keyCode || e.charCode) {
            case 38: // up
            case 37: // left
            case 33: // page up
                e.preventDefault();
                e.stopPropagation();
                this.setState({
                    focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1),
                });
                return false;
            case 39: // right
            case 40: // down
            case 34: // page down
                e.preventDefault();
                e.stopPropagation();
                this.setState({
                    focusedShareIcon: Math.min(type === 'text' ? 4 : 5, this.state.focusedShareIcon + 1),
                });
                return false;
            case 9: // tab
            case 27: // esc
                e.preventDefault();
                e.stopPropagation();
                this.shareBoxButton.focus();
                this.setState({
                    focusedShareIcon: 0,
                    shareBoxIsOpened: false,
                });
                return false;
        }
        return true;
    };
    FullscreenDesktopNavbar.prototype.getLoveButton = function () {
        var _a;
        var props = _.pick(this.props.current.item, [
            'id',
            'item',
            'idx',
            'itemId',
            'hashtag',
            'type',
            'customLoveCounter',
        ]);
        var loveButton = (React.createElement(LoveButton, __assign({}, props, { key: "fullscreen-love-".concat(this.props.id), layout: "fullscreen", device: "desktop", styles: this.props.styles, isPreview: this.props.isPreview, showCounter: true, actions: this.props.actions, customLoveCounterRenderer: (_a = this.props.customComponents) === null || _a === void 0 ? void 0 : _a.customLoveCounterRenderer }, this.props.current.itemLoveData)));
        return this.props.isPreview ? (React.createElement("div", { title: translationUtils.getByKey('This option is not available in editor') }, loveButton)) : (React.createElement(React.Fragment, null, loveButton));
    };
    FullscreenDesktopNavbar.prototype.getDownload = function () {
        return (React.createElement(FullscreenSocialDownload, { key: "fullscreen-download-".concat(this.props.id), layout: "fullscreen", device: "desktop", hasAdditionalNavbarElement: this.hasAdditionalNavbarElement(), current: this.props.current, customDownloadUrl: this.props.customDownloadUrl, styles: this.props.styles, actions: {
                eventsListener: this.props.actions.eventsListener,
            } }));
    };
    FullscreenDesktopNavbar.prototype.getShareComponent = function (showDownload, shareIcon) {
        var _this = this;
        var storeClass = this.hasAdditionalNavbarElement()
            ? 'pro-fullscreen-store'
            : '';
        var shareBoxOpenedClass = this.state.shareBoxIsOpened
            ? 'pro-fullscreen-hovered'
            : '';
        var type = this.props.current.item.type;
        return (React.createElement("div", { key: "shareComponent", className: "fullscreen-icon fullscreen-social-share-box ".concat(storeClass, " ").concat(shareBoxOpenedClass), onKeyDown: function (e) { return _this.handleShareArrowNavigation(e, type); } },
            shareIcon,
            !this.props.shouldUseNewSocialSharePopup && (React.createElement(FullscreenShareButtons, { item: this.props.current.item, focus: this.state.focusedShareIcon, ariaHidden: !this.state.shareBoxIsOpened, actions: {
                    eventsListener: this.props.actions.eventsListener,
                } }))));
    };
    FullscreenDesktopNavbar.prototype.getFakeShareComponent = function (showDownload, shareIcon) {
        var storeClass = this.hasAdditionalNavbarElement()
            ? 'pro-fullscreen-store'
            : '';
        return (React.createElement("div", { key: "fullscreen-social-share-box", className: "show-tooltip fullscreen-icon fullscreen-social-share-box ".concat(storeClass), title: translationUtils.getByKey('Gallery_Sharing_Disabled_In_Editor') }, shareIcon));
    };
    FullscreenDesktopNavbar.prototype.getShareIcon = function () {
        var _this = this;
        return (React.createElement("button", { key: "fullscreen-social-share-icon-".concat(this.props.id), className: "fullscreen-social-share-icon has-custom-focus", tabIndex: 0, title: "Share", ref: function (button) { return (_this.shareBoxButton = button); }, onClick: this.onShareIconClick, "aria-haspopup": "menu", "aria-pressed": this.state.shareBoxIsOpened },
            React.createElement(Share, null)));
    };
    FullscreenDesktopNavbar.prototype.onShareIconClick = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (this.props.shouldUseNewSocialSharePopup) {
            this.props.actions.eventsListener(FULLSCREEN_EVENTS.SOCIAL_SHARE_BUTTON_CLICKED, __assign(__assign({ showSocialSharePopup: true }, this.props), { title: ((_e = (_d = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.dto) === null || _d === void 0 ? void 0 : _d.metaData) === null || _e === void 0 ? void 0 : _e.title) || '', directShareLink: ((_j = (_h = (_g = (_f = this.props) === null || _f === void 0 ? void 0 : _f.current) === null || _g === void 0 ? void 0 : _g.item) === null || _h === void 0 ? void 0 : _h.dto) === null || _j === void 0 ? void 0 : _j.directShareLink) || '', createUrl: ((_m = (_l = (_k = this.props) === null || _k === void 0 ? void 0 : _k.current) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.createUrl) || undefined }));
        }
        else {
            if (this.state.shareBoxIsOpened) {
                this.setState({ shareBoxIsOpened: false });
            }
            else {
                this.setState({
                    shareBoxIsOpened: true,
                    focusedShareIcon: 1,
                });
            }
        }
    };
    FullscreenDesktopNavbar.prototype.getShareButtons = function () {
        var showDownload = this.props.styles.allowDownload && !this.props.current.item.isDemo;
        var shareIcon = this.getShareIcon();
        if (!this.props.styles.allowSocial) {
            return false;
        }
        return !this.props.isPreview
            ? this.getShareComponent(showDownload, shareIcon)
            : this.getFakeShareComponent(showDownload, shareIcon);
    };
    FullscreenDesktopNavbar.prototype.getAdditionalNavbarElement = function () {
        var additionalNavbarElement = this.props.additionalNavbarElement;
        try {
            if (additionalNavbarElement) {
                return additionalNavbarElement(__assign(__assign({}, this.props), { styleParams: this.props.styles }));
            }
            else {
                return false;
            }
        }
        catch (e) {
            console.error('Could not get additional sidebar element', e);
        }
    };
    FullscreenDesktopNavbar.prototype.getSocialBarContainer = function () {
        var styles = this.props.styles;
        var loveButton = styles.loveButton ? this.getLoveButton() : '';
        var downloadButton = this.getDownload();
        var shareButtons = this.getShareButtons();
        return (React.createElement("div", { className: "fullscreen-social" }, [
            !utils.isMobile() ? this.getExpandButtonIfNeeded() : false,
            this.getAdditionalNavbarElement(),
            this.getMoreInfoButton(),
            downloadButton,
            shareButtons,
            loveButton,
        ]));
    };
    FullscreenDesktopNavbar.prototype.getCloseShrinkButtonIfNeeded = function () {
        var _this = this;
        if (!this.props.currentWindow.expanded) {
            return false;
        }
        return (React.createElement(FullscreenExpandCloseButton, { iconClass: "progallery-svg-font-icons-shrink-arrow pro-fullscreen-shrink-button has-custom-focus", onClick: function () { return _this.props.actions.closeBrowserFullscreen(); }, tabIndex: 0, title: "Exit fullscreen", homeGalleryPageUrl: this.props.homeGalleryPageUrl }));
    };
    FullscreenDesktopNavbar.prototype.getCloseButton = function () {
        var _this = this;
        var button = (React.createElement(FullscreenExpandCloseButton, { key: "close-button", iconClass: "progallery-svg-font-icons-close-x pro-fullscreen-x-button has-custom-focus", onClick: function () {
                if (_this.props.currentWindow.expanded) {
                    _this.props.actions.closeBrowserFullscreen(true);
                }
                else {
                    var eventData = { itemIdx: _this.props.current.idx };
                    _this.props.actions.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
                }
            }, tabIndex: 0, title: "Exit ".concat(this.props.currentWindow.expanded ? 'fullscreen' : 'expand mode'), shouldRefocusOnCloseXButton: this.props.shouldRefocusOnCloseXButton, homeGalleryPageUrl: this.props.homeGalleryPageUrl }));
        return React.createElement("div", { className: "fullscreen-nav" }, button);
    };
    FullscreenDesktopNavbar.prototype.getMoreInfoButton = function () {
        var _a = this.props, styles = _a.styles, current = _a.current, actions = _a.actions, showInfo = _a.showInfo;
        var shouldHideMoreInfoButton = !styles.showInfoExpandButton ||
            this.props.currentWindow.expanded ||
            utils.isMobile() ||
            !current.hasInfo;
        if (shouldHideMoreInfoButton) {
            return false;
        }
        var svgInfoWhite = React.createElement(Info, null);
        var svgInfoBlack = React.createElement(InvertInfo, null);
        return (React.createElement("button", { key: "fullscreen-info-".concat(this.props.id), className: "fullscreen-icon fullscreen-info", onClick: function () { return actions.toggleInfo(); }, tabIndex: utils.getTabIndex('fullscreenInfo'), "aria-label": showInfo ? 'Hide Details' : 'Show More Details' }, showInfo ? svgInfoBlack : svgInfoWhite));
    };
    FullscreenDesktopNavbar.prototype.getExpandButtonIfNeeded = function () {
        var _this = this;
        var _a = this.props, styles = _a.styles, actions = _a.actions;
        if (!styles.allowFullscreenExpand) {
            return false;
        }
        var expandIconClass = 'progallery-svg-font-icons-expand-arrow';
        return (React.createElement("button", { key: "fullscreen-expand-".concat(this.props.id), className: "fullscreen-icon has-custom-focus fullscreen-expand ".concat(expandIconClass), onClick: function () { return actions.openBrowserFullscreen(); }, tabIndex: 0, title: "Open in fullscreen", ref: function (ref) { return (_this.fullscreenExpandButton = ref); } }));
    };
    FullscreenDesktopNavbar.prototype.getNavigationContainer = function () {
        return (React.createElement("div", { className: "fullscreen-nav" }, this.getCloseShrinkButtonIfNeeded()));
    };
    FullscreenDesktopNavbar.prototype.render = function () {
        var shouldHideSocialBar = this.props.currentWindow.expanded;
        var socialBarContainer = shouldHideSocialBar
            ? false
            : this.getSocialBarContainer();
        var navigationContainer = this.getNavigationContainer();
        var closeButton = this.getCloseButton();
        var isFullscreen = this.props.isFullscreen;
        var constructClassName = isFullscreen
            ? 'fullscreen-desktop-navbar-container fullscreen'
            : 'fullscreen-desktop-navbar-container';
        return (React.createElement("div", { className: constructClassName },
            socialBarContainer,
            navigationContainer,
            closeButton));
    };
    return FullscreenDesktopNavbar;
}(React.Component));
export default FullscreenDesktopNavbar;
//# sourceMappingURL=fullscreenDesktopNavbar.js.map